import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Text, TextPriority } from '..';

visualize('Text', () => {
  story('Basic', () => {
    snap('default props', <Text>Here is some text</Text>);
    snap(
      'with secondary priority',
      <Text priority={TextPriority.secondary}>Here is some text</Text>,
    );
  });
});
